import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsPartsCategories from './SettingsPartsCategories';

function PartsCategoriesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Parts Categories"
        subtitle="Product and parts categorization"
        backTo="/settings/operations-files"
        backLabel="Operations"
        sticky
      />
      <div className="p-6">
        <SettingsPartsCategories />
      </div>
    </div>
  );
}

export default PartsCategoriesPage;
